export default "__VITE_ASSET__40d82319__"